import {z} from 'zod'
import {createNumericKeyRecordSchema} from '../OptionalNumericKeyRecordSchema.ts'
import {createPartialStrictObjectSchemaWithAtLeastOneProperty} from '../PartialStrictObjectSchema.ts'
import {validateState} from '../ValidateState.ts'
import {PlayerColor} from '../PlayerState.ts'
import {TileEdgeDirection} from './TileEdgeState.ts'

export enum TileEdgePortType {
    Port = 1,
    PortLumber = 2,
    PortBrick = 3,
    PortWool = 4,
    PortGrain = 5,
    PortOre = 6,
}

export const portEdgeStateSchema = z
    .object({
        x: z.number().int().readonly(),
        y: z.number().int().readonly(),
        z: z.enum(TileEdgeDirection).readonly(),
        type: z.enum(TileEdgePortType).readonly(),
        owner: z.enum(PlayerColor).exclude(['None']).optional(),
    })
    .strict()

export type PortEdgeState = z.infer<typeof portEdgeStateSchema> & {
    readonly x: number
    readonly y: number
    readonly z: TileEdgeDirection
    readonly type: TileEdgePortType
}

export function validatePortEdgeState(data: unknown) {
    return validateState(portEdgeStateSchema, data)
}

export const portEdgeStatesSchema = createNumericKeyRecordSchema(portEdgeStateSchema)
export type PortEdgeStates = z.infer<typeof portEdgeStatesSchema>

export function validatePortEdgeStates(data: unknown) {
    return validateState(portEdgeStatesSchema, data)
}

export const portEdgeStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(portEdgeStateSchema)

export type PortEdgeStatePartial = z.infer<typeof portEdgeStatePartialSchema> & {
    readonly x?: number
    readonly y?: number
    readonly z?: TileEdgeDirection
    readonly type?: TileEdgePortType
}

export function validatePortEdgeStatePartial(data: unknown) {
    return validateState(portEdgeStatePartialSchema, data)
}

export const portEdgeStatesPartialSchema = createNumericKeyRecordSchema(portEdgeStatePartialSchema, {
    requireAtLeastOneEntry: true,
})
export type PortEdgeStatesPartial = z.infer<typeof portEdgeStatesPartialSchema>

export function validatePortEdgeStatesPartial(data: unknown) {
    return validateState(portEdgeStatesPartialSchema, data)
}
